import { render, staticRenderFns } from "./IssueFilter.vue?vue&type=template&id=5e689fca&scoped=true"
import script from "./IssueFilter.vue?vue&type=script&lang=js"
export * from "./IssueFilter.vue?vue&type=script&lang=js"
import style0 from "./IssueFilter.vue?vue&type=style&index=0&id=5e689fca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e689fca",
  null
  
)

export default component.exports